import React from "react";
import { connect } from "react-redux";
import { getTranslate, setActiveLanguage } from "react-localize-redux";
import { Switch, Redirect } from "react-router-dom";
import { renderToString } from "react-dom/server";
import { Modal, ModalHeader, ModalBody } from "reactstrap";
import moment from "moment";
import { isMobile } from "react-device-detect";
import axios from "axios";
import ReactJson from "react-json-view";
import cookie from "react-cookies";
import { actions } from "react-redux-form";
import { Steps } from "intro.js-react";
import { PrivateRoute, InternalProtectRoute } from "../../../../components";
import {
  userActions,
  settingActions,
  configActions,
  fileActions,
  documentActions,
  reportActions,
} from "../../../../redux/actions";
import {
  setAuthToken,
  handleErrors,
  getMomentLocaleByLang,
} from "../../../../utils";
import {
  externalSteps,
  initDocsSearchFormState,
  internalSteps,
  senderSteps,
} from "../../../../utils/constants";
import { NewReportWizardContainer } from "../../../../components/NewReportWizard/NewReportWizardContainer";

import { Files } from "../../Files";
import { Documents } from "../../Documents";
import { Configuration } from "../../Configuration";
import { Settings } from "../../Settings/Settings";
import { Dashboard } from "../../Dashboard";
import { Home } from "../../Home";
import { SmartSearch } from "../../SmartSearch";
import { Flows } from "../../Flows";
import ReportsDownloadForm from "../../Reports/DownloadForm/ReportsDownloadForm";
import UploadDeliveryDelaysExcel from "../../UploadDeliveryDelaysExcel/UploadDeliveryDelaysExcel";
import { Reports } from "../../Reports/Reports";
import { MsgModal } from "./MsgModal";

import { LoaderMask } from "./LoaderMask";
import { NewComerModal } from "./NewComerModal";
import { Topbar } from "./Topbar";
import { Footer } from "./Footer";
import { SmallScreenFooter } from "./SmallScreenFooter";

import "./HomePage.css";

const INTERVALTIME = 5000; // 5 secs

class HomePage extends React.Component {
  state = {
    fullEventModal: false,
    eventJsonObj: {},

    modalNewComer: false,

    stepsEnabled: false,
    initialStep: 0,
    steps: [],
  };

  handleLogout = () => {
    if (window.isEditingMode) {
      this.props.dispatch(configActions.toggleModalConfirm(true));
      this.props.dispatch(configActions.setConfirmDialogHandler(null));
    } else {
      this.props.dispatch(userActions.logout(this.props.history));
    }
  };

  handleChangeTimeZone = (selectedTimeZone) => {
    const { user, subUser, isSubUser } = this.props;
    let currentUser = user;
    if (isSubUser) {
      currentUser = subUser;
    }
    if (currentUser?.timeZone !== selectedTimeZone.value) {
      this.props.dispatch(
        settingActions.changeUserTimeZone(selectedTimeZone.value, currentUser)
      );
    }
  };

  handleLanguageChange = (selectedLanguage) => {
    const { user, subUser, isSubUser, dispatch } = this.props;
    let currentUser = user;
    if (isSubUser) {
      currentUser = subUser;
    }
    if (currentUser?.language !== selectedLanguage.value) {
      dispatch(setActiveLanguage(selectedLanguage.value));
      const _momentLocale = getMomentLocaleByLang(selectedLanguage.value);
      moment.locale(_momentLocale);
      dispatch(
        settingActions.changeUserLanguage(selectedLanguage.value, currentUser)
      );
    }
  };

  toggleFullEventModal = () => {
    this.setState({
      fullEventModal: !this.state.fullEventModal,
    });
  };

  handleOpenFullEventClick = (e, eventId) => {
    let params = {
        Id: eventId,
      },
      me = this;
    axios.get("Tracking/FullEvent", { params: params }).then((response) => {
      var json = response.data;
      if (json.Data) {
        me.setState({
          eventJsonObj: json.Data,
          fullEventModal: true,
        });
      }
    });
  };

  handleOpenDocsBucketClick = (e, doc, level, batchId) => {
    e.preventDefault();
    if (doc.docnodeid) {
      var idParts = doc.docnodeid.split("::");
      if (idParts.length > 2) {
        let params = {
            Platform: idParts[1],
            DobId: level === "doc" ? idParts[2] : batchId,
            Type: level,
          },
          me = this;
        axios
          .get("Tracking/GetDocsBucket", { params: params })
          .then((response) => {
            var json = response.data;
            if (json.Errors && json.Errors.length > 0) {
              handleErrors(json.Errors[0], me.props.dispatch);
              return;
            }
            if (json.Data) {
              me.setState({
                eventJsonObj: json.Data,
                fullEventModal: true,
              });
            }
          });
      }
    }
  };

  handleOpenEndpointsClick = (e, doc, level, batchId) => {
    e.preventDefault();
    if (doc.docnodeid) {
      var idParts = doc.docnodeid.split("::");
      if (idParts.length > 2) {
        let params = {
            Platform: idParts[1],
            Id: level === "doc" ? idParts[2] : batchId,
            Level: level,
          },
          me = this;
        axios
          .get("Tracking/GetEndpoints", { params: params })
          .then((response) => {
            var json = response.data;
            if (json.Errors && json.Errors.length > 0) {
              handleErrors(json.Errors[0], me.props.dispatch);
              return;
            }
            if (json.Data) {
              me.setState({
                eventJsonObj: json.Data,
                fullEventModal: true,
              });
            }
          });
      }
    }
  };

  handleShowParametersClick = (e, doc, paramsOnly) => {
    e.preventDefault();
    if (doc.docnodeid) {
      let params = {
          uniqueid: doc.docnodeid,
        },
        me = this;
      axios
        .get("Tracking/getparkeddocument", { params: params })
        .then((response) => {
          var json = response.data;
          if (json.Errors && json.Errors.length > 0) {
            handleErrors(json.Errors[0], me.props.dispatch);
            return;
          }
          if (json.Data) {
            me.setState({
              eventJsonObj: !!paramsOnly
                ? json.Data && json.Data.esv
                : json.Data,
              fullEventModal: true,
            });
          }
        });
    }
  };

  handleNewComerOKClick = () => {
    // call server method to set the isNewUser property to false
    const { user, isSubUser, subUser, isSender, translate } = this.props;
    let currentUser = user;
    if (isSubUser) {
      currentUser = subUser;
    }
    this.props.dispatch(settingActions.changeNewUserState(false, currentUser));
    this.setState({
      modalNewComer: false,
    });
    if (!isMobile) {
      this.setState({
        stepsEnabled: true,
        steps: isSubUser
          ? isSender
            ? senderSteps.map((item) => ({
                ...item,
                intro: renderToString(translate(item.intro)),
              }))
            : externalSteps.map((item) => ({
                ...item,
                intro: renderToString(translate(item.intro)),
              }))
          : internalSteps.map((item) => ({
              ...item,
              intro: renderToString(translate(item.intro)),
            })),
      });
    }
  };

  onIntroExit = () => {
    this.setState(() => ({ stepsEnabled: false }));
  };

  checkAndShowDownload = async (pipelineid, targetAction) => {
    const { dispatch, translate } = this.props;
    try {
      let params = {
        SearchText: pipelineid,
        PageNumber: 1,
        IsPlatformSpecific: false,
        Size: 50,
      };
      const response = await axios.get("Reporting/reports", { params: params });
      let reCheckAgain = true;
      if (response.data.Errors && response.data.Errors.length > 0) {
        handleErrors(response.data.Errors[0], dispatch, "Download File");
        reCheckAgain = false;
      } else if (
        response.data.ValidationErrors &&
        response.data.ValidationErrors.length > 0
      ) {
        handleErrors(
          response.data.ValidationErrors[0],
          dispatch,
          "Download File"
        );
        reCheckAgain = false;
      } else if (response.data.Data && response.data.Data.length > 0) {
        const downloadReport = response.data.Data[0];
        if (
          downloadReport.reportStatus &&
          downloadReport.reportStatus.st === "finished"
        ) {
          reCheckAgain = false;
          const components = downloadReport.components || [];
          let fullPath = "";
          components.forEach((item) => {
            if (item.type === "exec") {
              if (
                item.additionalInfo &&
                item.additionalInfo.generatedFiles &&
                item.additionalInfo.generatedFiles.length
              ) {
                fullPath = item.additionalInfo.generatedFiles[0];
              }
            }
          });
          if (fullPath) {
            params = {
              PipelineId: pipelineid,
              FileLocation: fullPath,
            };
            dispatch(targetAction.setDownloadFileParams(params));
            dispatch(targetAction.toggleDownLoadSpinner(false));
          } else {
            dispatch(targetAction.toggleDownLoadSpinner(false));
            handleErrors(
              "Server failed to prepare download file",
              dispatch,
              "Download File"
            );
          }
        } else if (
          downloadReport.reportStatus &&
          downloadReport.reportStatus.st === "failed"
        ) {
          reCheckAgain = false;
          dispatch(targetAction.toggleDownLoadSpinner(false));
          handleErrors(
            translate("FileGenerationFailedMsg"),
            dispatch,
            "Download File"
          );
        }
      }
      if (reCheckAgain) {
        setTimeout(() => {
          this.checkAndShowDownload(pipelineid, targetAction);
        }, INTERVALTIME);
      }
    } catch (error) {
      handleErrors(error, dispatch, "Downloading file");
      dispatch(targetAction.toggleDownLoadSpinner(false));
    }
  };

  checkAndShowSendingEmail = async (pipelineid, targetAction) => {
    const { dispatch, translate } = this.props;
    try {
      let params = {
        SearchText: pipelineid,
        PageNumber: 1,
        IsPlatformSpecific: false,
        Size: 50,
      };
      const response = await axios.get("Reporting/reports", { params: params });
      let reCheckAgain = true;
      if (response.data.Errors && response.data.Errors.length > 0) {
        handleErrors(
          response.data.Errors[0],
          dispatch,
          "Sending Download File"
        );
        reCheckAgain = false;
      } else if (
        response.data.ValidationErrors &&
        response.data.ValidationErrors.length > 0
      ) {
        handleErrors(
          response.data.ValidationErrors[0],
          dispatch,
          "Sending Download File"
        );
        reCheckAgain = false;
      } else if (response.data.Data && response.data.Data.length > 0) {
        const downloadReport = response.data.Data[0];
        if (
          downloadReport.reportStatus &&
          downloadReport.reportStatus.st === "finished"
        ) {
          reCheckAgain = false;
          dispatch(targetAction.toggleDownLoadSpinner(false));
          dispatch(targetAction.setEmailSent(true));
          setTimeout(() => {
            dispatch(targetAction.setEmailSent(false));
          }, 5000);
        } else if (
          downloadReport.reportStatus &&
          downloadReport.reportStatus.st === "failed"
        ) {
          reCheckAgain = false;
          dispatch(targetAction.toggleDownLoadSpinner(false));
          // email failed but download ready
          const components = downloadReport.components || [];
          let fullPath = "";
          components.forEach((item) => {
            if (item.type === "exec") {
              if (
                item.state &&
                item.state.st === "finished" &&
                item.additionalInfo &&
                item.additionalInfo.generatedFiles &&
                item.additionalInfo.generatedFiles.length
              ) {
                fullPath = item.additionalInfo.generatedFiles[0];
              }
            }
          });
          if (fullPath) {
            params = {
              PipelineId: pipelineid,
              FileLocation: fullPath,
            };
            dispatch(targetAction.setEmailFailedButDownloadReady(params));
          } else {
            handleErrors(
              translate("FileGenerationFailedMsg"),
              dispatch,
              "Sending Download File"
            );
          }
        }
      }
      if (reCheckAgain) {
        setTimeout(() => {
          this.checkAndShowSendingEmail(pipelineid, targetAction);
        }, INTERVALTIME);
      }
    } catch (error) {
      handleErrors(error, dispatch, "Downloading file");
      dispatch(targetAction.toggleDownLoadSpinner(false));
    }
  };

  componentDidMount() {
    const { user, isSubUser, subUser, dispatch, history } = this.props;
    window.loggedInBrowserHistory = history;
    let currentUser = user;
    if (isSubUser) {
      currentUser = subUser;
    }
    if (currentUser && currentUser?.language) {
      dispatch(setActiveLanguage(currentUser?.language));
      const _momentLocale = getMomentLocaleByLang(currentUser?.language);
      moment.locale(_momentLocale);
    }
    if (currentUser && currentUser?.newUser) {
      this.setState({
        modalNewComer: true,
      });
    }
    setTimeout(function () {
      if (window.NTT.NTTLoader) {
        window.NTT.NTTLoader.increment = 1;
        window.NTT.NTTLoader.intervalTime = 200;
        window.NTT.NTTLoader.loadStep("Almost there! 3, 2, 1...", 85, 100);
      }
    }, 1500);
    setTimeout(function () {
      if (window.NTT.NTTLoader) {
        window.NTT.NTTLoader.hideLoader();
      }
    }, 2700);
    let downloadLoadingForFiles = localStorage.getItem(
      "downloadLoadingForFiles"
    );
    let downloadLoadingForDocuments = localStorage.getItem(
      "downloadLoadingForDocuments"
    );
    let downloadPipelineId = localStorage.getItem("downloadPipelineId");
    let isSendingEmail = localStorage.getItem("isSendingEmail");
    let downloadFileUserId = localStorage.getItem("downloadFileUserId");
    if (downloadFileUserId === currentUser?.userId) {
      if (!!downloadLoadingForFiles || !!downloadLoadingForDocuments) {
        let targetAction = downloadLoadingForFiles
          ? fileActions
          : documentActions;
        setTimeout(() => {
          if (!!isSendingEmail) {
            this.checkAndShowSendingEmail(downloadPipelineId, targetAction);
          } else {
            this.checkAndShowDownload(downloadPipelineId, targetAction);
          }
        }, INTERVALTIME);
      }
    }
  }

  // Bind the class context to history change listener
  historyChangeListener = (location) => {
    const {
      dispatch,
      files,
      documents,
      translate,
      isSubUser,
      subUser,
      user
    } = this.props;

    const currentUser = isSubUser ? subUser : user;
    const qs = require("qs");
    const _prevHash = localStorage.getItem("LastLocationHash");
    const _newHash = location.pathname.toString();

    if (_newHash !== "/login") {
      localStorage.setItem("LastLocationHash", location.pathname.toString());
    }

    if (location.pathname.startsWith("/documents")) {
      const _docSearch = location.search.split("?")[1];

      if (
          documents.listFromFileLoaded &&
          ((_docSearch && _prevHash.startsWith("/files")) ||
              _prevHash.startsWith("/documents"))
      ) {
        documents.listFromFileLoaded = false;
        dispatch(documentActions.clearDocuments());
      }

      if (_docSearch) {
        const queryDocObj = qs.parse(_docSearch);

        if (
            queryDocObj["DocUniqueId"] &&
            !documents.error &&
            !documents.loading &&
            !documents.withUniqueId
        ) {
          const params = {
            PageNumber: 1,
            Size: currentUser?.pageItemCount || 20,
            DocUniqueId: queryDocObj["DocUniqueId"],
          };

          dispatch(configActions.resetDocsActiveTab());
          dispatch(configActions.resetDocsInstances());
          dispatch(configActions.resetDocumentDeliveryData());
          dispatch(documentActions.getListFromFile(params, true));
        } else if (
            queryDocObj["file_event_id"] &&
            !documents.error &&
            !documents.loading &&
            !documents.listFromFileLoaded
        ) {
          const params = {
            PageNumber: 1,
            Size: currentUser?.pageItemCount || 20,
            FileId: queryDocObj["file_event_id"],
          };

          if (queryDocObj["fidfs"]) {
            params["fidfs"] = queryDocObj["fidfs"];
          }

          if (queryDocObj["channel"])
            params["FileChannel"] = queryDocObj["channel"];

          // Force setting customerId for subuser if present in the url
          if (isSubUser) {
            params["CustomerId"] = subUser?.customerGlobalId;
          }

          let CustomerId = null;

          if (queryDocObj["CustomerId"]) {
            params["CustomerId"] = queryDocObj["CustomerId"];
            if (
                !isSubUser ||
                queryDocObj["CustomerId"] !== subUser?.customerGlobalId
            ) {
              CustomerId = queryDocObj["CustomerId"];
            }
          }

          dispatch(
              actions.change("docSearch", {
                ...initDocsSearchFormState,
                CustomerId,
                Size: currentUser?.pageItemCount || 20,
              })
          );
          dispatch(configActions.resetDocsActiveTab());
          dispatch(configActions.resetDocsInstances());
          dispatch(configActions.resetDocumentDeliveryData());
          dispatch(documentActions.getListFromFile(params));
        }
      }
    } else if (location.pathname.startsWith("/files")) {
      const _filesSearch = location.search.split("?")[1];

      if (
          files.listFromFileLoaded &&
          ((_filesSearch && _prevHash.startsWith("/documents")) ||
              _prevHash.startsWith("/files"))
      ) {
        files.listFromFileLoaded = false;
        dispatch(fileActions.clearFiles());
      }
      if (_filesSearch) {
        const queryFilesObj = qs.parse(_filesSearch);

        if (
            queryFilesObj["flowid"] &&
            queryFilesObj["platform"] &&
            !files.error &&
            !files.loading &&
            !files.listFromFileLoaded
        ) {
          let params = {
            PageNumber: 1,
            Size: currentUser?.pageItemCount || 20,
            FlowId: queryFilesObj["flowid"],
            Platform: queryFilesObj["platform"],
          };

          if (queryFilesObj["sncts"]) {
            params["sncts"] = queryFilesObj["sncts"];
          }

          // Force setting customerId for subuser if present in the url
          if (isSubUser) {
            params["CustomerId"] = subUser?.customerGlobalId;
          }

          if (queryFilesObj["CustomerId"]) {
            params["CustomerId"] = queryFilesObj["CustomerId"];

            if (
                !isSubUser ||
                queryFilesObj["CustomerId"] !== subUser?.customerGlobalId
            ) {
              dispatch(
                  actions.change(
                      "fileSearch.CustomerId",
                      queryFilesObj["CustomerId"]
                  )
              );
            }
          }

          dispatch(
              fileActions.getAllStartFilesDetails(
                  params,
                  `${ translate("LoadingFiles") }...`
              )
          );
        }

        if (
            queryFilesObj["fileId"] &&
            !files.cleared &&
            !files.error &&
            !files.loading &&
            !files.listFromFileLoaded
        ) {
          let params = {
            PageNumber: 1,
            Size: currentUser?.pageItemCount || 20,
            FileId: queryFilesObj["fileId"],
          };

          if (queryFilesObj["sncts"]) {
            params["sncts"] = queryFilesObj["sncts"];
          }

          if (queryFilesObj["fidFs"]) {
            params["fidFs"] = queryFilesObj["fidFs"];
          }

          // Force setting customerId for subuser if present in the url
          if (isSubUser) {
            params["CustomerId"] = subUser?.customerGlobalId;
          }

          if (queryFilesObj["CustomerId"]) {
            params["CustomerId"] = queryFilesObj["CustomerId"];

            if (
                !isSubUser ||
                queryFilesObj["CustomerId"] !== subUser?.customerGlobalId
            ) {
              dispatch(
                  actions.change(
                      "fileSearch.CustomerId",
                      queryFilesObj["CustomerId"]
                  )
              );
            }
          }

          dispatch(
              fileActions.getAllByFileId(
                  params,
                  `${ translate("LoadingFiles") }...`
              )
          );
        }
      }
    } else if (location.pathname.startsWith("/exec-reports")) {
      dispatch(reportActions.setDefaultReportPage("/exec-reports"));

      const _reportSearch = location.search.split("?")[1];

      if (_reportSearch) {
        let queryReportObj = qs.parse(_reportSearch);

        if (queryReportObj["config_report_id"]) {
          let params = {
            PageNumber: 1,
            Size: 20,
            reportDefinitionId: queryReportObj["config_report_id"],
          };

          // Force setting customerId for subuser if present in the url
          if (isSubUser) {
            params["CustomerId"] = subUser?.customerGlobalId;
          }

          if (queryReportObj["CustomerId"]) {
            params["CustomerId"] = queryReportObj["CustomerId"];

            if (
                !isSubUser ||
                queryReportObj["CustomerId"] !== subUser?.customerGlobalId
            ) {
              dispatch(
                  actions.change(
                      "execReportSearch.CustomerId",
                      queryReportObj["CustomerId"]
                  )
              );
            }
          }
          dispatch(actions.change(`execReportSearch.SearchText`, ""));
          dispatch(actions.change(`execReportSearch.PageNumber`, 1));
          dispatch(reportActions.getExecReportsFromURIQuery(params));
        } else if (queryReportObj["search"]) {
          dispatch(
              actions.change(
                  `execReportSearch.SearchText`,
                  queryReportObj["search"]
              )
          );
          dispatch(actions.change(`execReportSearch.PageNumber`, 1));

          let params = {
            PageNumber: 1,
            Size: 20,
            SearchText: queryReportObj["search"],
          };

          if (isSubUser) {
            params["CustomerId"] = subUser?.customerGlobalId;
          }
          dispatch(reportActions.getExecutedReports(params));
        }
      }
    } else if (location.pathname.startsWith("/config-reports")) {
      dispatch(reportActions.setDefaultReportPage("/config-reports"));
    }
  }

  componentWillMount() {
    const {
      dispatch,
      isSubUser,
      isSender,
      subUser,
      history,
    } = this.props;
    setAuthToken(cookie.load("AuthToken"));
    dispatch(settingActions.getAvailableTimeZones());
    dispatch(configActions.getReportsDescriptionsJson());
    if (isSubUser) {
      if (!isSender) {
        dispatch(configActions.setExternalUserData(subUser?.customerGlobalId));
      }
    } else {
      dispatch(configActions.getActiveCustomers());
      dispatch(configActions.getPlatformNames());
      dispatch(settingActions.getAvailableUsers());
      dispatch(settingActions.getChannnelList());
      dispatch(settingActions.getSlaCalenderList());
      dispatch(settingActions.getPlatformsList());
    }
    dispatch(configActions.getAllChannels({ ExternalView: isSubUser }));

    history.listen(this.historyChangeListener);

    let params = {
      ConfigItemId: "UMS_PORTAL_URL",
    };
    axios
      .get("Configuration/GetConfigItem", { params: params })
      .then((response) => {
        const data = response.data;
        if (typeof data === "object") {
          if (data.Errors && data.Errors.length) {
            //TODO: show error message
          }
        } else if (typeof data === "string") {
          window.AddUsersToUMSLink = data;
        }
      });

    window.ActiveFileMaxAgeDays = 2; // default 2 days
    params = {
      ConfigItemId: "ACTIVE_FILE_MAX_AGE_DAYS",
    };
    axios
      .get("Configuration/GetConfigItem", { params: params })
      .then((response) => {
        const data = response.data;
        if (data) {
          if (typeof data === "object") {
            if (data.Errors && data.Errors.length) {
              //TODO: show error message
            }
          } else if (typeof data === "string") {
            window.ActiveFileMaxAgeDays = parseInt(data);
          }
        }
      });

    params = {
      ConfigItemId: "DEFAULT_SEARCH_PERIOD_MONTHS",
    };
    axios
      .get("Configuration/GetConfigItem", { params: params })
      .then((response) => {
        var data = response.data;
        var _periodMonths = parseInt(data);
        if (!isNaN(_periodMonths) && _periodMonths > 0) {
          this.props.dispatch(
            configActions.setDefaultSearchPeriod(_periodMonths)
          );
          var _from = moment
            .utc()
            .subtract(_periodMonths, "month")
            .add(1, "day")
            .set({ hour: 0, minute: 0, second: 0, millisecond: 0 })
            .toDate();
          var _to = moment
            .utc()
            .set({ hour: 23, minute: 59, second: 59, millisecond: 999 })
            .toDate();

          this.props.dispatch(actions.change("fileSearch.Start", _from));
          this.props.dispatch(actions.change("fileSearch.End", _to));

          this.props.dispatch(actions.change("docSearch.Start", _from));
          this.props.dispatch(actions.change("docSearch.End", _to));

          this.props.dispatch(actions.change("execReportSearch.Start", _from));
          this.props.dispatch(actions.change("execReportSearch.End", _to));
        }
      });
    params = {
      ConfigItemId: "LIST_OF_DOCUMENT_TAGS",
    };
    axios
      .get("Configuration/GetConfigItem", { params: params })
      .then((response) => {
        var dataOptions = (response.data || "").split(",");
        const tagsOptions = [];
        const tagsIcons = {};
        dataOptions.forEach((item) => {
          if (!!item) {
            var _tagSplits = item.split(":");
            tagsOptions.push({ value: _tagSplits[0], label: _tagSplits[0] });
            if (_tagSplits.length > 1) {
              tagsIcons[_tagSplits[0].toLowerCase()] = _tagSplits[1];
            }
          }
        });
        this.props.dispatch(
          configActions.setTagsOptions(
            tagsOptions,
            Object.keys(tagsIcons).length ? tagsIcons : null
          )
        );
      });
  }

  render() {
    const {
      user,
      subUser,
      isSubUser,
      isSender,
      availableTimeZones,
      translate,
    } = this.props;
    const { stepsEnabled, steps, initialStep, modalNewComer } = this.state;
    let currentUser = user;
    if (isSubUser) {
      currentUser = subUser;
    }
    const { timeZone, language, pageItemCount } = currentUser || {};

    var tzOptions = (availableTimeZones || []).map((item) => {
      return { value: item.id, label: item.displayName };
    });
    return (
      <div className="home-page-container">
        <Steps
          enabled={stepsEnabled}
          steps={steps}
          initialStep={initialStep}
          onExit={this.onIntroExit}
        />
        <LoaderMask />
        <div className="container-fluid p_in home-page-content">
          <Topbar
            handleLogout={this.handleLogout}
            tzOptions={tzOptions}
            handleChangeTimeZone={this.handleChangeTimeZone}
            handleLanguageChange={this.handleLanguageChange}
          />
          <div className="force-show-footer">
            <Switch>
              {isSubUser && !isSender && (
                <PrivateRoute exact path="/home" component={Home} />
              )}
              {!isSubUser && (
                <InternalProtectRoute path="/dashboard" component={Dashboard} />
              )}
              {!this.props.isSender && (
                <PrivateRoute
                  exact
                  path="/files"
                  component={() => (
                    <Files
                      isExternalUser={isSubUser}
                      defaultSize={pageItemCount}
                      externalCustomerId={
                        subUser ? subUser?.customerGlobalId : null
                      }
                    />
                  )}
                />
              )}
              <PrivateRoute
                exact
                path="/documents"
                component={() => (
                  <Documents
                    isExternalUser={isSubUser}
                    isSender={isSender}
                    externalCustomerId={
                      subUser ? subUser?.customerGlobalId : null
                    }
                    defaultSize={pageItemCount}
                    handleOpenFullEventClick={this.handleOpenFullEventClick}
                    handleOpenDocsBucketClick={this.handleOpenDocsBucketClick}
                    handleOpenEndpointsClick={this.handleOpenEndpointsClick}
                    handleShowParametersClick={this.handleShowParametersClick}
                  />
                )}
              />
              {!isSubUser && (
                <PrivateRoute
                  exact
                  path="/uploaddeliverydelaysexcel"
                  component={() => (
                    <UploadDeliveryDelaysExcel
                      isExternalUser={isSubUser}
                      isSender={isSender}
                      externalCustomerId={
                        subUser ? subUser?.customerGlobalId : null
                      }
                      defaultSize={pageItemCount}
                      handleOpenFullEventClick={this.handleOpenFullEventClick}
                      handleOpenDocsBucketClick={this.handleOpenDocsBucketClick}
                      handleOpenEndpointsClick={this.handleOpenEndpointsClick}
                    />
                  )}
                />
              )}
              {!isSender && (
                <PrivateRoute
                  exact
                  path={"/:path(exec-reports|config-reports)"}
                  component={Reports}
                />
              )}
              {!isSubUser && (
                <InternalProtectRoute
                  exact
                  path="/customers"
                  component={Configuration}
                />
              )}
              {!isSubUser && (
                <InternalProtectRoute
                  exact
                  path="/settings"
                  component={() => (
                    <Settings
                      externalCustomerId={
                        subUser ? subUser?.customerGlobalId : null
                      }
                    />
                  )}
                />
              )}
              <PrivateRoute exact path="/flows" component={Flows} />
              {!isSubUser && (
                <PrivateRoute
                  exact
                  path="/smart-search"
                  component={SmartSearch}
                />
              )}
              <PrivateRoute
                exact
                path="/download-files"
                component={() => (
                  <ReportsDownloadForm isExternalUser={isSubUser} />
                )}
              />
              {!isSender ? (
                <Redirect from="/" to={isSubUser ? "/home" : "/files"} />
              ) : (
                <Redirect from="/" to="/documents" />
              )}
            </Switch>
          </div>
        </div>
        <SmallScreenFooter handleLogout={this.handleLogout} />
        <Footer />
        <Modal
          style={{ width: "70vw", maxWidth: "95vw" }}
          isOpen={this.state.fullEventModal}
          toggle={this.toggleFullEventModal}
        >
          <ModalHeader toggle={this.toggleFullEventModal}>
            {translate("Details")}
          </ModalHeader>
          <ModalBody>
            <ReactJson displayDataTypes={false} src={this.state.eventJsonObj} />
          </ModalBody>
        </Modal>
        <NewComerModal
          modalNewComer={modalNewComer}
          timeZone={timeZone}
          tzOptions={tzOptions}
          handleChangeTimeZone={this.handleChangeTimeZone}
          handleLanguageChange={this.handleLanguageChange}
          language={language}
          handleNewComerOKClick={this.handleNewComerOKClick}
        />
        <MsgModal />
        <NewReportWizardContainer />
      </div>
    );
  }
}

function mapStateToProps(state) {
  const {
    files,
    documents,
    locale,
    authentication: { user, subUser, isSubUser, isSender },
    settings: { availableTimeZones },
  } = state;

  return {
    user,
    subUser,
    isSubUser,
    isSender,
    files,
    documents,
    availableTimeZones,
    translate: getTranslate(locale),
  };
}

const connectedHomePage = connect(mapStateToProps)(HomePage);
export { connectedHomePage as HomePage };
